import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ErrorPage({ error, resetError }) {
    var _a;
    const message = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : 'Unknown error';
    return (_jsxs("div", { id: "error-page", children: [_jsx("h1", { children: "Oops!" }), _jsx("p", { children: "Sorry, an unexpected error has occurred." }), _jsx("p", { children: _jsx("i", { children: message }) }), typeof resetError === 'function' && (_jsx("button", { type: "button", onClick: resetError, children: "Retry" }))] }));
}
